import { cn } from "lib/cn";

/** The tint over a `useFileDrop` target while files are dragged over it, or while they upload.
 *  Put it in a non-scrolling `relative` box: inside a scroller it would scroll away. The
 *  label is centred, and sticky so it stays on screen over a target taller than the page. */
export const FileDropOverlay = ({
    isDragActive,
    isUploading = false,
    className,
}: {
    isDragActive: boolean;
    isUploading?: boolean;
    className?: string;
}) => {
    if (!isDragActive && !isUploading) return null;
    return (
        <div
            className={cn(
                "pointer-events-none absolute inset-0 z-10 flex items-center justify-center rounded-md bg-blue-50/80 ring-2 ring-blue-400",
                className,
            )}
        >
            <div className="sticky top-4 bottom-4 text-sm font-medium text-blue-700">
                {isUploading ? "Uploading…" : "Drop files to attach"}
            </div>
        </div>
    );
};
